export default __webpack_public_path__ + "static/media/20201206-IMG_1333.e2085599.webp";